import { createContext, useCallback, useContext, useState } from 'react'

const VideoModalContext = createContext({
  isOpen: false,
  language: 'de',
  openVideo: () => {},
  closeVideo: () => {}
})

export const VideoModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [language, setLanguage] = useState('de')
  // openVideo optionally receives the active language so the modal can pick the
  // matching video. Callers live inside the i18next page context; the modal
  // itself is mounted at the root (wrapRootElement), outside that context.
  const openVideo = useCallback((lang) => {
    if (typeof lang === 'string') setLanguage(lang)
    setIsOpen(true)
  }, [])
  const closeVideo = useCallback(() => setIsOpen(false), [])
  return (
    <VideoModalContext.Provider
      value={{ isOpen, language, openVideo, closeVideo }}
    >
      {children}
    </VideoModalContext.Provider>
  )
}

export const useVideoModal = () => useContext(VideoModalContext)
